import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Page, Button, Spinner, TableList, PageContentHeader } from 'seagull';
import { routes } from "../../../constants";
import TableFilters from "../components/TableFilters/TableFilters";
import { selectors } from "../../../store/state-selectors";
import { useSortFromUrl } from "../../../hooks/useSortFromUrl";
import { formatLongMonthUSDate } from "../../../utils";
import { useIoContext, useStore, useStoreActions } from "../../../contexts";
import { filterLabels, headerItems, makeCsv, makeFiltersConfig, remainingCreditReportColumnDefs, remainingCreditReportHeaderColumnDefsForExport, sortIds, defaultSort } from "./RemainingCredit.utils";
import { FilterType } from "./types";
import { RemainingCreditRow } from "./RemainingCreditRow";
const title = 'Remaining Credit Report';
export const RemainingCreditReport = () => {
  const businessName = useStore(selectors.user.businessName);
  const {
    api
  } = useStoreActions();
  const history = useHistory();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [availableCustomers, setAvailableCustomers] = useState([]);
  const [availableAgreements, setAvailableAgreements] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const {
    sort,
    changeSort
  } = useSortFromUrl({
    defaultSort,
    sortIds
  });
  const {
    downloadCsv
  } = useIoContext();
  const filtersConfig = useMemo(() => makeFiltersConfig(availableServices, availableCustomers, availableAgreements), [availableServices, availableCustomers, availableAgreements]);
  useEffect(() => {
    document.title = title;
    api.reports.remainingCreditReportServices().then(setAvailableServices);
    api.reports.remainingCreditReportCustomers().then(setAvailableCustomers);
    api.reports.remainingCreditReportAgreements().then(setAvailableAgreements);
  }, []);
  const fetchRemainingCreditReport = () => {
    setIsRefreshing(true);
    api.reports.remainingCreditReport({
      customers: selectedFilters[FilterType.CustomerName] || [],
      services: selectedFilters[FilterType.ServiceName] || [],
      agreements: selectedFilters[FilterType.AgreementName] || [],
      sort: sort ? [sortIds[sort.colIndex], sort.sort] : undefined
    }).then(data => {
      setReportData(data);
      setIsRefreshing(false);
    });
  };
  useEffect(() => {
    fetchRemainingCreditReport();
  }, [selectedFilters, sort]);
  return /*#__PURE__*/React.createElement(Page, {
    "data-testid": "remaining-credit-report",
    header: "Remaining Credit Report",
    variant: "containedHeight",
    onClickBack: () => history.push(routes.reports),
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primary",
      "data-testid": "export-report-btn",
      onClick: () => downloadCsv(makeCsv(remainingCreditReportHeaderColumnDefsForExport.map(_ref => {
        let {
          value
        } = _ref;
        return value;
      }), reportData), "".concat(businessName, "_remaining_credit_report_").concat(formatLongMonthUSDate(new Date()), ".csv"))
    }, "Export"))
  }, /*#__PURE__*/React.createElement(TableList.Provider, {
    columnDefs: remainingCreditReportColumnDefs,
    numRows: reportData.length,
    sort: sort,
    onSortChange: changeSort
  }, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBlockEnd: '24px'
    }
  }, /*#__PURE__*/React.createElement(TableFilters, {
    testIdPrefix: "remaining-credit-report",
    filterLabels: filterLabels,
    filterConfig: filtersConfig,
    selectedFilters: selectedFilters,
    setSelectedFilters: setSelectedFilters,
    onRefresh: fetchRemainingCreditReport
  }))), /*#__PURE__*/React.createElement(TableList.Structure, {
    header: /*#__PURE__*/React.createElement(TableList.Header, {
      stickyToTop: true,
      items: headerItems,
      "data-testid": "remaining-credit-report-table-header"
    }),
    content: isRefreshing ? /*#__PURE__*/React.createElement("div", {
      "data-testid": "remaining-credit-table-loading"
    }, /*#__PURE__*/React.createElement(Spinner, {
      centeredInBox: true
    })) : reportData.length ? reportData.map((reportRow, index) => /*#__PURE__*/React.createElement(RemainingCreditRow, {
      key: "".concat(reportRow.customerName, "-").concat(reportRow.serviceName, "-").concat(index),
      index: index,
      data: reportRow
    })) : null
  })));
};